import * as t from './actionTypes';
import { getTrackerState } from './selectors';

const loading = type => ({
  type,
});

export const loadDetailsByCode = ({ airportCode }) => async (dispatch, getStore, client) => {
  dispatch(loading(t.LOAD_DETAILS_BY_CODE));

  try {
    const data = await client.get(`/airport/${airportCode}`);
    const selectedState = getTrackerState(data);

    const result = {
      ...data,
      ...selectedState,
    };

    return dispatch({
      type: t.LOAD_DETAILS_SUCCESS,
      result,
    });
  } catch (e) {
    // dispatch load fail
  }
};

export const setAirport = (airport, triggeredByEnter) => ({
  type: t.SET_AIRPORT,
  airport,
  triggeredByEnter,
});

export const setSecondaryAction = bool => ({
  type: t.SET_SECONDARY_ACTION,
  bool,
});



// WEBPACK FOOTER //
// ./modules/AirportCurrentConditions/redux/actions.js